import {
  Avatar as AvatarBase,
  Box,
  Button as ButtonBase,
  MenuItem as MenuItemBase,
  styled,
  Typography,
} from '@mui/material';

export const AccountPopoverTitleWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  padding: ${(p) => p.theme.spacing(0.5)} ${(p) => p.theme.spacing(1)};
  background-color: ${(p) =>
    p.theme.palette.mode === 'light'
      ? p.theme.palette.grey[200]
      : p.theme.palette.background.paper};
  border-radius: ${(p) => p.theme.spacing(1)};
  width: 100%;
  gap: ${(p) => p.theme.spacing(0.5)};
`;

export const AccountPopoverEmailText = styled(Typography)`
  font-size: ${(p) => p.theme.typography.body4.fontSize};
  font-weight: ${(p) => p.theme.typography.fontWeightMedium};
  color: ${(p) =>
    p.theme.palette.mode === 'light'
      ? p.theme.palette.grey[500]
      : p.theme.palette.grey[200]};
  display: flex;
  gap: ${(p) => p.theme.spacing(0.5)};
`;

export const AccountPopoverUserTypeText = styled(Typography)`
  font-size: ${(p) => p.theme.typography.body4.fontSize};
  font-weight: ${(p) => p.theme.typography.fontWeightMedium};
  color: ${(p) =>
    p.theme.palette.mode === 'light'
      ? p.theme.palette.grey[500]
      : p.theme.palette.grey[200]};
  text-transform: capitalize;
`;

export const AccountPopoverBorderedBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: ${(p) => p.theme.spacing(1)};
  border: solid 1px
    ${(p) =>
      p.theme.palette.mode === 'light'
        ? p.theme.palette.primary[50]
        : p.theme.palette.grey[700]};
  padding: ${(p) => p.theme.spacing(1)} ${(p) => p.theme.spacing(2)};
`;

export const MenuItem = styled(MenuItemBase)`
  padding: ${(p) => p.theme.spacing(0.5)} ${(p) => p.theme.spacing(2)};
  border-radius: 0;

  :hover {
    color: ${(p) => p.theme.palette.primary[500]};
  }
`;

export const MenuItemLogout = styled(MenuItemBase)`
  padding: ${(p) => p.theme.spacing(1)};
  border-radius: 0;
  color: ${(p) => p.theme.palette.error[500]};
  font-size: ${(p) => p.theme.typography.body4.fontSize};
  font-weight: ${(p) => p.theme.typography.fontWeightMedium};
  gap: ${(p) => p.theme.spacing(1)};
  border-top: solid 1px ${(p) => p.theme.palette.grey[300]};
`;

export const Avatar = styled(AvatarBase)`
  /* border: solid 1px ${(p) => p.theme.palette.primary[200]} !important;

  &:hover {
    border: solid 1px ${(p) => p.theme.palette.primary[500]} !important;
  } */
`;

export const CreditInfo = styled(Box)`
  border: 1px solid ${(p) => p.theme.palette.grey[300]};
  border-radius: ${(p) => p.theme.spacing(1)};
  padding: ${(p) => p.theme.spacing(1.5)};
`;

export const AccountPopoverButton = styled(ButtonBase)`
  &:focus {
    border-color: ${(p) => p.theme.palette.primary[500]};
  }
`;
